import { LAYOUT_LABELS, type BarLayout } from './layout'
import { useTunerStore } from '../../state/tuner-store'

const LAYOUTS: readonly BarLayout[] = ['stacked', 'columns']

/** Switch between the tablature-style stack and the head-on column view. */
export function LayoutToggle(): React.JSX.Element {
  const layout = useTunerStore((state) => state.layout)
  const setLayout = useTunerStore((state) => state.setLayout)

  return (
    <div className="layout-toggle" role="group" aria-label="Anordnung der Balken">
      {LAYOUTS.map((candidate) => (
        <button
          key={candidate}
          type="button"
          className="layout-toggle__button"
          aria-pressed={layout === candidate}
          title={LAYOUT_LABELS[candidate]}
          onClick={() => {
            setLayout(candidate)
          }}
        >
          {candidate === 'stacked' ? 'Untereinander' : 'Spalten'}
        </button>
      ))}
    </div>
  )
}
